module.exports = __webpack_public_path__ + "img/14d-doc-acao-ciencia.074180fc.png";